import Slider from "react-slick";
import "react-multi-carousel/lib/styles.css";
import EuropRightSec from "./raps-europe/europe-component/europ-right-sec";
import EuropeLeftSec from "./raps-europe/europe-component/europe-left-sec";
//import EuropSingleImageSlider from "./raps-europe/europe-component/europ-single-image-slider";
//import NetworkGroupCard from "./raps-europe/europe-component/network-group-card";
//import SpotLightImage from "./raps-europe/europe-component/spotlight-image";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import ContainerLayout from "../../layouts/two-columns/container-layout";
import { RootState, useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { retrieveRAPSHighlights } from "../../redux/slice/raps-highlights-slice";

import { useDynamicScripts } from "../../hooks/useDynamicScript";
import LoadingComp from "../../components/re-usable/loading/loading";

const RapsEurope = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [htmlString, setHtmlString] = useState("");
  const [scriptHtmlString, setScriptHtmlString] = useState("");
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const { rapsHighlights } = useSelector((state: RootState) => state.rapsHighlights);
  const dispatch = useAppDispatch();
  const path = "%2FWho-We-Are%2FRAPS-Europe"; // RAPS-Europe page content
  const breadcrumbPath = "Who-We-Are%2FRAPS-Europe"; // RAPS-Europe page breadcrumbPath content
  const pramotionsPath = "%2FWho-We-Are%2FRAPS-Europe%2FStage-Banners"; // pramotions content

  var settings = {
    dots: true,
    arrows: true,
    slidesToShow: 1,
    adaptiveHeight: true,
  };

  // use Effect for window width
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowWidth]);

  // useEffect for API call
  useEffect(() => {
    dispatch(retrievePageMenu(path));
    dispatch(retrieveRAPSHighlights(pramotionsPath));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      if (RapsEuropeData[0].result[0] && RapsEuropeData[0].result[0].description) {
        setHtmlString(RapsEuropeData[0].result[0].description);

        if (RapsEuropeData[0].result[0].javaScriptField) {
          setScriptHtmlString(RapsEuropeData[0].result[0].javaScriptField);
        }
      }
    }
  }, [RapsEuropeData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <ContainerLayout breadcrumbPath={breadcrumbPath} isBreadcrumbPath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
        {/* Europe slide cards  */}
        <div className="widget">
          <div className="tabs tabs-responsive">
            <div className="featured-heroes slick-on-mobile alt">
              {windowWidth < 961 ? (
                <Slider {...settings}>
                  {rapsHighlights.map((item, index) => {
                    return item.type === "hero-primary" ? <EuropeLeftSec key={index} content={item} /> : <EuropRightSec key={index} content={item} />;
                  })}
                </Slider>
              ) : (
                <>
                  {rapsHighlights.map((item, index) => {
                    return item.type === "hero-primary" ? <EuropeLeftSec key={index} content={item} /> : <EuropRightSec key={index} content={item} />;
                  })}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
        </div>
      </ContainerLayout>
    </>
  );
};

export default RapsEurope;
